import { ChangeDetectorRef } from '@angular/core';
import { EventEmitter, Output, ViewChild } from '@angular/core';
import { SimpleChanges } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { DevicePilomat } from 'src/app/model/devicePilomat';
import { DeviceService } from 'src/app/service/device.service';
import { Log } from 'src/app/util/log';
import { MatCheckboxModule } from '@angular/material/checkbox';


@Component({
  selector: 'app-add-group-devices-list',
  templateUrl: './add-group-devices-list.component.html',
  styleUrls: ['./add-group-devices-list.component.css']
})
export class AddGroupDevicesListComponent implements OnInit {


  @ViewChild('deviceslisttable', { static: true }) table;
  @ViewChild('deviceslistloader', { static: true }) loader;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Input() deviceList: DevicePilomat[];
  @Input() usergroup: string;
  @Input() devicesWithExpiredPermissions;
  @Input() canUserEdit;


  @Output() onDeviceSelected = new EventEmitter<DevicePilomat>();
  @Output() onDeviceDeselected = new EventEmitter<DevicePilomat>();
  @Output() selectedDeviceEmitter = new EventEmitter<DevicePilomat>();

  displayedColumns: string[] = ['checkbox', 'serial', 'name', 'permissions', 'modifyPermissions'];

  dataSource: MatTableDataSource<DevicePilomat>;

  constructor(private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
  }


  ngAfterViewInit() {

    // setTimeout(() => {
    //   this.loader.hideLoading();
    // });
  }

  onKey(event: any) {
    let filterString = event.target.value;
    this.table.dataSource.filter = filterString.trim().toLowerCase();
  }

  filterTable(data: DevicePilomat, filter: string): boolean {

    if (data.systemInfo && data.systemInfo.name && data.systemInfo.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.systemInfo && data.systemInfo.serial && data.systemInfo.serial.indexOf(filter) != -1) {
      return true;
    }
    return false;
  }

  loadData() {
    this.table.dataSource = new MatTableDataSource(this.deviceList);
    this.table.dataSource.filterPredicate = this.filterTable;
    this.table.dataSource.sort = this.sort;
    this.loader.hideLoading();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.loader.showLoading();
    this.loadData();
    this.loader.hideLoading();
  }

  // gets the device that is checked in the list
  addSelectedDevice(device) {
    if (device.selected) {
      device.selected = false;
      device.shortPermissions = " - ";
      this.onDeviceDeselected.emit(device);
    } else {
      device.selected = true;
      this.onDeviceSelected.emit(device);
    }
  }

  modifyPermissions(device) {
    this.selectedDeviceEmitter.emit(device);
  }

  hasExpiredPermissions(device: DevicePilomat): boolean {
    if (this.devicesWithExpiredPermissions.includes(device.serial)) {
      return true;
    } else {
      return false;
    }
  }
}
